{
  "en": {
    "validations": {
      "dialogFormat": "Please mark the two speakers with **Name**: at the beginning of each line, followed by the spoken text. Use one line per turn and no other ** markers in the text.",
      "email": "Please enter a valid email address.",
      "embeddedAppNotFound": "The embedded content could not be found.",
      "groupCountTooLarge": "The number of groups must be smaller than the total number of names.",
      "groupSizeTooLarge": "The number of members per group must be smaller than the total number of names.",
      "groupSizeTooSmall": "Your group count would be above the maximum of 20. Increase the number of members per group or lower the total number of names.",
      "integer": "Please enter an integer.",
      "isYoutubeOrVimeoUrl": "Please enter a valid YouTube or Vimeo URL.",
      "linkedAppNotFound": "The linked content could not be found.",
      "maxLength": "Maximum {max} selectable.",
      "maxLengthValue": "Maximum length is {max} characters.",
      "minLength": "At least {min} characters.",
      "namesCountTooLarge": "Please enter a maximum of 100 names.",
      "namesCountTooSmall": "Please enter at least two names.",
      "required": "This field is mandatory.",
      "requiredIf": "This field is mandatory.",
      "tooManyWords": "Please enter a maximum of {count} words.",
      "url": "Please enter a valid URL (starting with https://).",
      "validEmbedCode": "Please enter a valid URL or an iframe code snippet.",
      "validUrl": "Please enter a valid URL.",
      "maxValue": "The value must not exceed {max}.",
      "minValue": "The value must be at least {min}.",
      "youtubeOrVimeoUrl": "Please enter a valid YouTube or Vimeo URL."
    }
  }
}
